import React from 'react'
import './App.css'

import NameInput from './components/NameInput'
import Loader from './components/Loader'

function App() {
	return <NameInput />
}

export default App
